import {
  GENERATE_IMAGE,
  GET_IMAGE_GENERATED,
  IMAGE_GENERATION_IN_PROGRESS
} from "@/store/imageGeneration/imageGenerationAction";
import axios from "axios";
import { BACK_ENDPOINT } from "@/store/conf/api";
import delay from "delay";
import { log } from "@/utils/log";

export const LLM_API = BACK_ENDPOINT + "/llm";
const IMAGE_GENERATION_API = LLM_API + '/generateImage';
export default {
  state: {
    isGenerationInProgress: false,
  },
  mutations: {
    [IMAGE_GENERATION_IN_PROGRESS]: (state: any, value: boolean) => {
      state.isGenerationInProgress=value;
    },
  },
  getters: {
    isImageGenerationInProgress: (state: any): boolean => {
      return state.isGenerationInProgress;
    },
  },
  actions: {
    [IMAGE_GENERATION_IN_PROGRESS]({commit, dispatch}: { commit: any, dispatch: any },index:number) {
      commit(IMAGE_GENERATION_IN_PROGRESS,index)
    },
    async [GENERATE_IMAGE]({commit, dispatch}: { commit: any, dispatch: any }, {
      prompt,style,orientation,pro,
    }:{prompt:string,style:string,orientation:'portrait'|'landscape'|'square',pro?:number}) {
      commit(IMAGE_GENERATION_IN_PROGRESS,true);

      const DELAY = 2000;
      const TIMEOUT = 120000 + (pro === 2 ? 30000 : 0);
      const MAX_RETRIES = 2;

      const attemptGeneration = async (): Promise<string> => {
        const resp = await axios({
          url: IMAGE_GENERATION_API,
          method: 'POST',
          data: {
            'prompt': prompt,
            'style': style,
            'orientation': orientation,
            'pro': pro ?? 1,
          },
        });

        const jobID = resp.data;
        let imageGenerationResponseB64: string = "";
        let elapsedTime = 0;

        while (!imageGenerationResponseB64) {
          await delay(DELAY);
          elapsedTime += DELAY;

          if (elapsedTime >= TIMEOUT) {
            const timeoutError = new Error("Timeout waiting for image generation");
            (timeoutError as any).isTimeout = true;
            throw timeoutError;
          }

          imageGenerationResponseB64 = await dispatch(GET_IMAGE_GENERATED, jobID);
          if (imageGenerationResponseB64 === "ERROR") {
            throw new Error("Impossible to generate image, please try again later");
          }
        }

        return imageGenerationResponseB64;
      };

      let lastError: any | null = null;
      for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
        try {
          return await attemptGeneration();
        } catch (err: any) {
          lastError = err;
          if (err.isTimeout && attempt < MAX_RETRIES) {
            log.warn(`Timeout waiting for image generation (attempt ${attempt}/${MAX_RETRIES}), retrying...`);
            // Retry only on timeout
            continue;
          }
          break;
        }
      }

      if (lastError) {
        if (lastError.data) {
          lastError = (lastError as any).data;
        }
        throw lastError;
      }
      throw new Error("Impossible to generate image, please try again later");
    },
    async [GET_IMAGE_GENERATED]({commit, dispatch}: { commit: any, dispatch: any }, jobID:string) {
      return await axios({
        url: IMAGE_GENERATION_API+'/'+jobID,
        method: 'GET',
      }).then((resp) => {
        return resp.data;
      }).catch((err) => {
        if (err.data) {
          err = err.data;
        }
        throw err;
      })
    }
  },
};
